<template>
  <div class="equity-card-table" v-loading="loading">
    <el-radio-group v-model="feeType" @change="changeRadio">
      <el-radio-button label="1">办卡</el-radio-button>
      <el-radio-button label="2">退卡</el-radio-button>
    </el-radio-group>
    <div class="search">
      <Search ref="search" :search-data="searchData" @searchChange="searchChange" />
    </div>
    <div class="table">
      <div style="padding-bottom:10px" v-if="feeType == '1'">
        办卡数量：{{ total ? total : 0 }} 笔
        <span style="padding-left:20px"
          >办卡收入：{{ totalPirce ? totalPirce : 0 }}元</span
        >
      </div>
      <div style="padding-bottom:10px" v-if="feeType == '2'">
        退卡数量：{{ total ? total : 0 }} 笔
        <span style="padding-left:20px"
          >退款金额：{{ totalPirce ? totalPirce : 0 }}元</span
        >
      </div>
      <Table
        :serial-number="true"
        :key="searchForm.feeType"
        :current-value="searchForm.current"
        :header-style="headerStyle"
        :height="'calc(100vh - 370px)'"
        :tooltipShow="true"
        :orientation="'center'"
        :table-data="tableData"
        :title-list="feeType == '1' ? titleListData : titleListData2"
        :total="total"
        @handleCurrentChange="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import Search from "@/components/search";
import Table from "@/components/table2";
import {
  getFinancialBillCardFee,
  exportCardFeel,
} from "@/api/store/accounting";
export default {
  components: {
    Search,
    Table,
  },
  data() {
    return {
      searchData: [
        {
          prop: "userPhone",
          label: "客户查询",
          type: "text",
          text: "输入手机号",
        },
        {
          typeList: [
            {
              name: "查询",
              code: "search",
              type: "primary",
            },
            {
              name: "重置",
              code: "reset",
              type: "primary",
            },
            {
              name: "导出",
              code: "export",
              type: "primary",
              loading: false,
            },
          ],
           labelWidth:'20px'
        },
      ],
      headerStyle: {
        fontSize: "14px",
        background: "#EFF1F2",
        color: "black",
      },
      tableData: [],
      titleListData: [
        {
          prop: "storeName",
          label: "办卡门店",
        },
        {
          prop: "userName",
          label: "用户",
        },
        {
          prop: "userPhone",
          label: "手机号",
        },
        {
          prop: "cardName",
          label: "卡种",
        },
        {
          prop: "payPrice",
          label: "实收金额（元）",
        },
        {
          prop: "applyTime",
          label: "办卡时间",
          width: 150,
        },
        {
          prop: "operateUserName",
          label: "操作人",
        },
      ],
      titleListData2: [
        {
          prop: "storeName",
          label: "办卡门店",
        },
        {
          prop: "userName",
          label: "用户",
        },
        {
          prop: "userPhone",
          label: "手机号",
        },
        {
          prop: "cardName",
          label: "卡种",
        },
        {
          prop: "refundPrice",
          label: "退款金额（元）",
        },
        {
          prop: "applyTime",
          label: "办卡时间",
          width: 150,
        },
        {
          prop: "refundTime",
          label: "退款时间",
          width: 150,
        },
        {
          prop: "operateUserName",
          label: "操作人",
        },
      ],
      total: 0,
      totalPirce: 0,
      searchForm: {
        size: 10,
        current: 1,
      },
      feeType: 0,
      loading: false,
    };
  },
  watch: {
    $route: {
      handler: function(value) {
        if (value.query.status) {
          this.feeType = value.query.status;
          this.searchForm.financialBillId = value.query.id;
          if (this.feeType == 1) {
            this.searchForm.feeType = 3;
          } else {
            this.searchForm.feeType = 4;
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.getFinancialBillCardFeeList();
  },
  methods: {
    //  获取权益卡明细
    getFinancialBillCardFeeList() {
      this.loading = true;
      getFinancialBillCardFee({ ...this.searchForm })
        .then(({ data }) => {
          if (data.code == 0) {
            this.tableData = data.data.records;
            this.totalPirce = data.data.totalSum;
            this.total = data.data.total;
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 切换标签触发
    changeRadio() {
      this.searchForm = {
        size: 10,
        current: 1,
        feeType: this.feeType == 1 ? 3 : 4,
        financialBillId: this.searchForm.financialBillId,
      };
      this.$refs.search.queryInfo("resetData");
      this.getFinancialBillCardFeeList();
    },
    // 搜索触发
    searchChange({ code, formData }) {
      if (code == "search") {
        this.searchForm = {
          ...this.searchForm,
          ...formData,
          size: 10,
          current: 1,
        };
        this.getFinancialBillCardFeeList();
      } else if (code == "reset") {
        this.searchForm = {
          financialBillId: this.searchForm.financialBillId,
          size: 10,
          current: 1,
          feeType: this.feeType == 1 ? 3 : 4,
        };
        this.getFinancialBillCardFeeList();
      } else if (code == "export") {
        this.searchForm = {
          ...this.searchForm,
          ...formData,
          size: 10,
          current: 1,
        };
        this.searchData[this.searchData.length - 1].typeList[2].loading = true;
        exportCardFeel({
          financialBillId: this.searchForm.financialBillId,
          feeType: this.searchForm.feeType,
          userPhone: this.searchForm.userPhone,
        })
          .then((response) => {
            if (response.status !== 200)
              return this.$message.error("导出失败,请重试!");
            const filename = decodeURI(
              response.headers["content-disposition"]
                .split(";")[1]
                .split("= ")[1]
            );
            const blob = new Blob([response.data], {
              type: "application/vnd.ms-excel",
            });
            let url = window.URL.createObjectURL(blob);
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            this.$message.success("导出成功!");
            document.body.removeChild(link);
            this.searchData[
              this.searchData.length - 1
            ].typeList[2].loading = false;
          })
          .catch(() => {
            this.$message.error("导出失败!");
            this.searchData[
              this.searchData.length - 1
            ].typeList[2].loading = false;
          });
      }
    },

    // 改变页码触发
    handleCurrentChange(val) {
      this.searchForm.current = val;
      this.getFinancialBillCardFeeList();
    },
  },
};
</script>

<style lang="scss" scoped>
.equity-card-table {
  .search {
    margin: 10px 0;
  }
  .table {
    font-size: 14px;
  }
}
</style>
